var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-ons-page',[_c('custom-toolbar',{attrs:{"title":'Asset Overview',"action":_vm.toggleMenu}}),_c('div',{staticClass:"content-box"},[_c('TableAllAssets')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }